import GATSBY_COMPILED_MDX from "/opt/build/repo/content/blog/what-is-the-event-loop-in-javascript/index.md";
import * as React from "react";
import {Link, graphql} from "gatsby";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Kofi from "../components/ko-fi";
import SeriesNav from "../components/SeriesNav";
const BlogPostTemplate = ({data: {previous, next, site, mdx: post}, location, pageContext, children}) => {
  const siteTitle = site.siteMetadata?.title || `Title`;
  const {seriesPosts} = pageContext || ({});
  const fields = post.fields;
  return React.createElement(Layout, {
    location: location,
    title: siteTitle
  }, React.createElement("article", {
    className: "blog-post",
    itemScope: true,
    itemType: "http://schema.org/Article"
  }, React.createElement("header", null, React.createElement("h1", {
    itemProp: "headline"
  }, post.frontmatter.title), React.createElement("p", null, post.frontmatter.category && React.createElement("span", {
    className: "category-pill"
  }, post.frontmatter.category), post.frontmatter.date, fields?.wordCount > 0 && React.createElement("span", {
    style: {
      marginLeft: '0.75rem',
      color: 'inherit',
      opacity: 0.6
    }
  }, "· ", Math.max(1, Math.round(fields.wordCount / 200)), " min read"))), post.frontmatter.series && seriesPosts && seriesPosts.length > 0 && React.createElement(SeriesNav, {
    seriesSlug: post.frontmatter.series,
    currentSlug: post.fields.slug,
    seriesPosts: seriesPosts
  }), React.createElement("section", {
    itemProp: "articleBody"
  }, children), React.createElement(Kofi), React.createElement("hr"), React.createElement("footer")), React.createElement("nav", {
    className: "blog-post-nav"
  }, React.createElement("ul", {
    style: {
      display: `flex`,
      flexWrap: `wrap`,
      justifyContent: `space-between`,
      listStyle: `none`,
      padding: 0
    }
  }, React.createElement("li", null, previous && React.createElement(Link, {
    to: previous.fields.slug,
    rel: "prev"
  }, "← ", previous.frontmatter.title)), React.createElement("li", null, next && React.createElement(Link, {
    to: next.fields.slug,
    rel: "next"
  }, next.frontmatter.title, " →")))));
};
export const Head = ({data: {mdx: post}}) => {
  return React.createElement(Seo, {
    title: post.frontmatter.title,
    description: post.frontmatter.description || post.excerpt
  });
};
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      fields {
        slug
        wordCount
      }
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        category
        series
        seriesOrder
      }
    }
    previous: mdx(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: mdx(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`;
